'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = undefined;

var _Collection = require('./Collection');

var _Collection2 = _interopRequireDefault(_Collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Collection2.default;
exports.Collection = _Collection2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/Collection/index.js
// module id = 1399
// module chunks = 0